import React, { useState } from 'react';
import { toast } from 'react-semantic-toasts';
import { captureException } from '@playbookux/playbook-web-core';
import { useMutation } from '@apollo/client';
import {
  bool, func, shape, string,
} from 'prop-types';
import UPDATE_COLLECT_BYO_TESTERS_INFO from './graphql';
import {
  Container,
  Divider,
  ButtonContainer,
  Link,
  Option,
  OptionsContainer,
  Text,
  Title,
  Radio,
  SaveButton,
  Section,
} from './styles';
import { TOAST_ERROR_TIME, TOAST_SUCCESS_TIME } from '../../constants';
import { LEARN_MORE_LINK } from './constants';

const InfoCollectionSection = (props) => {
  const { currentCompany, onFetchCompanies } = props;

  const [byoInfoCollection, setByoInfoCollection] = useState(currentCompany.collectByoTestersInfo);

  const [updateCollectByoTestersInfo, { loading }] = useMutation(UPDATE_COLLECT_BYO_TESTERS_INFO, {
    onCompleted: async () => {
      await onFetchCompanies();
      toast({
        type: 'info',
        description: 'Your updates have been saved!',
        time: TOAST_SUCCESS_TIME,
      });
    },
    onError: () => {
      toast({
        type: 'error',
        title: 'Error',
        description: 'Error while updating.',
        time: TOAST_ERROR_TIME,
      });
    },
  });

  const handleUpdateCollectByoTestersInfo = async () => {
    try {
      await updateCollectByoTestersInfo({
        variables: {
          collectByoTestersInfo: byoInfoCollection,
          companyId: currentCompany.id,
          skip: !currentCompany,
        },
      });
    } catch (err) {
      captureException('UPDATE_COLLECT_BYO_TESTERS_INFO_ERROR', err);
      toast({
        type: 'error',
        title: 'Error',
        description: 'Error while updating.',
        time: TOAST_ERROR_TIME,
      });
    }
  };

  return (
    <Container>
      <Section>
        <Title>&apos;Bring your own participants&apos; information collection</Title>

        <Text>
          By default PlaybookUX will collect the participants name on the first page of a
          ‘bring your own participants’ study. This setting allows you to bypass collecting a
          participants name and instead PlaybookUX will assign a random identifier after the
          study is uploaded.
          <Link href={LEARN_MORE_LINK} target="_blank"> Learn more</Link>
        </Text>

        <OptionsContainer>
          <Option>
            <Radio
              checked={byoInfoCollection}
              onClick={() => setByoInfoCollection(true)}
            />
            <Text>Collect first and last name</Text>
          </Option>
          <Option>
            <Radio
              checked={!byoInfoCollection}
              onClick={() => setByoInfoCollection(false)}
            />
            <Text>Assign a random identifier (no personal information collected)</Text>
          </Option>
        </OptionsContainer>

        <ButtonContainer>
          <SaveButton
            onClick={handleUpdateCollectByoTestersInfo}
            disabled={loading}
            loading={loading}
          >
            Save
          </SaveButton>
        </ButtonContainer>
      </Section>

      <Divider />
    </Container>
  );
};

InfoCollectionSection.propTypes = {
  currentCompany: shape({
    id: string.isRequired,
    collectByoTestersInfo: bool.isRequired,
  }).isRequired,
  onFetchCompanies: func.isRequired,
};

export default InfoCollectionSection;
